import { DataContext } from "../../../helper/HelperOne"
import NavBar from "../../nav_bar/Navbar"
import { useState } from "react"
import MissingQuotationLeadList from "./MissingQuotationLeadList"

const MissingQuotationLead = () => {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)
    return (
        <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
            <NavBar
                childrenPage={<MissingQuotationLeadList />}
                menuId={10}
            />
        </DataContext.Provider>
    )
}

export default MissingQuotationLead